import { Component, Input, Output, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { InterfaceEmployee } from 'app/models/employee.model';
import { EmployeeService } from 'app/services/employee.service';
import { IndicatorService } from 'app/services/indicator.service';

@Component({
  selector: 'app-employee-detail',
  templateUrl: './employee-detail.component.html',
  styleUrls: ['./employee-detail.component.scss']
})
export class EmployeeDetailComponent implements OnInit {

  @Input() employee: InterfaceEmployee;
  @Output() closeDetail: EventEmitter<boolean> = new EventEmitter(false);

  constructor(
    protected employeeService: EmployeeService,
    protected indicatorService: IndicatorService
  ) { }

  ngOnInit(): void { }

  goBack(): void {
    this.closeDetail.next(true);
  }

}
